import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const FiscalRuleRoutes = [
  {
    path: '/fiscal-rules',
    name: 'ListFiscalRules',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'fiscal_rules:list'
    }
  },
  {
    path: '/fiscal-rule/',
    name: 'CreateFiscalRule',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'fiscal_rules:create'
    }
  },
  {
    path: '/fiscal-rule/:id',
    name: 'UpdateFiscalRule',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'fiscal_rules:update'
    }
  },
  {
    path: '/fiscal-rule/view/:id',
    name: 'GetFiscalRule',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'fiscal_rules:get'
    }
  }
]
